import { Segmented, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useThemeStore, type ThemeMode } from '@shared/lib/theme-store';

const OPTIONS = [
  { value: 'light', icon: <SunOutlined /> },
  { value: 'system', icon: <DesktopOutlined /> },
  { value: 'dark', icon: <MoonOutlined /> },
] as const;

export function ThemeToggle() {
  const { t } = useTranslation();
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);
  const label = t(`theme.${mode}`);
  return (
    <Tooltip title={label}>
      <Segmented
        size="small"
        value={mode}
        onChange={(v) => setMode(v as ThemeMode)}
        options={OPTIONS.map((o) => ({ value: o.value, icon: o.icon }))}
      />
    </Tooltip>
  );
}
